__turbopack_context__.v({
  "card": "jMVNFa_card",
  "cardImg": "jMVNFa_cardImg",
  "cardTitle": "jMVNFa_cardTitle",
  "dot": "jMVNFa_dot",
  "dotActive": "jMVNFa_dotActive",
  "dotFill": "jMVNFa_dotFill",
  "dots": "jMVNFa_dots",
  "eyebrow": "jMVNFa_eyebrow",
  "head": "jMVNFa_head",
  "learn": "jMVNFa_learn",
  "outer": "jMVNFa_outer",
  "pill": "jMVNFa_pill",
  "reference": "jMVNFa_reference",
  "result": "jMVNFa_result",
  "resultLabel": "jMVNFa_resultLabel",
  "scrim": "jMVNFa_scrim",
  "slide": "jMVNFa_slide",
  "title": "jMVNFa_title",
  "titleMuted": "jMVNFa_titleMuted",
  "top": "jMVNFa_top",
  "track": "jMVNFa_track",
  "viewport": "jMVNFa_viewport",
});
